// extracted by mini-css-extract-plugin
module.exports = {"imgStyle":"aboutUs_imgStyle__3Roko","title":"aboutUs_title__284Tk","imgProfile":"aboutUs_imgProfile__OyHAA","disclaimer":"aboutUs_disclaimer__21eMN"};